import { useLevelofSupport } from 'features/claims/claimsHooks'
import { ClaimsPageHeader } from 'features/claims/components'
import { Outlet } from 'react-router-dom'
import styled from 'styled-components'

export const AllClaims = () => {
  localStorage.setItem('levelOfSupport', JSON.stringify(useLevelofSupport().data))

  return (
    <Div>
      <ClaimsPageHeader />

      <div className="tabs-nav-container">
        <Outlet />
      </div>
    </Div>
  )
}

const Div = styled.div`
  height: calc(100vh - ${({ theme }) => theme.constants.navbarHeight});
  position: relative;
  .sidebar-container {
    float: left;
  }
  .tabs-nav-container {
    padding: 0px ${({ theme }) => theme.spacing.m};
  }
`
